/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */

/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/cloud-exercise/v0.ts
 */
import { createValidator } from '../../helpers/validator';
export var CloudExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    blueprintFileName: {
      type: 'string',
      title: 'Blueprint file name',
      description: 'The file name of the blueprint to use for creation a session.'
    },
    cloudProvider: {
      type: 'string',
      enum: ['azure'],
      title: 'Cloud provider',
      description: 'The cloud provider to use for creating a session.'
    },
    forceNewSession: {
      type: 'boolean',
      default: false,
      description: 'Should the exercise create a new session, even if one already exists?'
    },
    instructionSteps: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          hint: {
            type: 'string',
            description: 'The hint text for this step.'
          },
          instructions: {
            type: 'string',
            description: 'The instructions text for this step.'
          }
        },
        required: ['hint', 'instructions']
      },
      description: 'Incremental instruction steps. These can not be empty.'
    },
    question: {
      anyOf: [{
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['Open'],
            default: 'Open'
          },
          openQuestions: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                question: {
                  type: 'string',
                  description: 'Question asked to the user.'
                },
                solution: {
                  type: 'object',
                  properties: {
                    answer: {
                      type: 'string',
                      description: 'Correct answer to the question.'
                    },
                    message: {
                      type: 'string',
                      description: 'Feedback message when the submission matches the pattern.'
                    },
                    pattern: {
                      type: 'string',
                      description: 'Regex that should validate the correctness of the submission.'
                    }
                  },
                  required: ['answer', 'message', 'pattern']
                },
                feedback: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      message: {
                        type: 'string',
                        description: 'Feedback message when the submission matches the pattern.'
                      },
                      pattern: {
                        type: 'string',
                        description: 'If the regex matches, the feedback message will be shown. The last pattern should be ".*" to show a default error message.'
                      }
                    },
                    required: ['message', 'pattern']
                  },
                  description: 'List of feedback displayed when the submission is incorrect.'
                }
              },
              required: ['question', 'solution', 'feedback']
            },
            description: 'List of open questions.'
          }
        },
        required: ['flavor', 'openQuestions'],
        title: 'Open'
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['PureMultipleChoiceInSteps'],
            default: 'PureMultipleChoiceInSteps'
          },
          solutionItems: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                answer: {
                  type: 'string',
                  default: 'Wrong answer',
                  description: 'Possible answer choice.'
                },
                feedback: {
                  type: 'string',
                  default: 'Error message',
                  description: 'Feedback message for the submission. For the correct answer this is the success message.'
                },
                correct: {
                  type: 'boolean',
                  default: false,
                  description: 'Check a single box for the correct answer.'
                }
              },
              required: ['answer', 'feedback', 'correct']
            },
            description: 'List of possible answers. Use the arrows on the left-hand side to change the order, or the X to remove the item.'
          },
          question: {
            type: 'string',
            default: ''
          }
        },
        required: ['flavor', 'solutionItems'],
        title: 'MultipleChoiceSingleAnswer'
      }]
    },
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    }
  },
  required: ['assignment', 'blueprintFileName', 'chapter_id', 'cloudProvider', 'course_id', 'hint', 'instructionSteps', 'question', 'title', 'xp'],
  definitions: {}
};
export var isValidCloudExerciseV0 = createValidator(CloudExerciseV0Schema);
export var CloudExerciseV0Definition = {
  schema: CloudExerciseV0Schema,
  validate: isValidCloudExerciseV0
};